import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
export var propTypes = {
  /**
   * @ignore
   */
  active: PropTypes.bool,

  /**
   * @ignore
   */
  color: PropTypes.string,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object
};
export var defaultProps = {
  active: false,
  color: '#FFFFFF',
  colorConfig: colors
};

var normalizeColor = function normalizeColor(color) {
  var sanitizedColor = color.toLowerCase();

  switch (sanitizedColor) {
    case 'jet black':
      return '#4A4A4A';

    case 'silver':
      return '#DEDEDE';

    case 'gold':
      return '#D6C6A9';

    case 'rose gold':
      return '#F6D6BE';

    case 'black':
      return '#000000';

    default:
      return sanitizedColor || '#FFFFFF';
  }
};
/**
 * @ignore
 */


var ColorSwatch = /*#__PURE__*/styled.div.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "ColorSwatch",
  componentId: "xxl4gt-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: inline-block;\n  height: ", ";\n  margin: ", ";\n  max-width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  outline: none;\n  position: relative;\n  width: ", ";\n\n  ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return normalizeColor(color);
}, function (_ref2) {
  var size = _ref2.size;
  return calculateRem(size);
}, function (_ref3) {
  var swatchMargin = _ref3.swatchMargin;
  return swatchMargin;
}, calculateRem(56), function (_ref4) {
  var size = _ref4.size;
  return calculateRem(size);
}, function (_ref5) {
  var size = _ref5.size;
  return calculateRem(size);
}, function (_ref6) {
  var size = _ref6.size;
  return calculateRem(size);
}, function (_ref7) {
  var active = _ref7.active,
      selected = _ref7.selected,
      disabled = _ref7.disabled,
      colorConfig = _ref7.colorConfig;
  return !active && !selected && !disabled && "\n    border: 1px solid ".concat(colorConfig.coolGray6, ";\n\n  ");
});
ColorSwatch.propTypes = propTypes;
ColorSwatch.defaultProps = defaultProps;
export default ColorSwatch;